import React from "react";
import { Row, Col, Table } from "react-bootstrap";

export default function PMPODetailsTab({ order, items }) {
  if (!order) return null;

  // Calculate totals from items if available, otherwise use order totals
  const orderItems = items || order.items || [];
  const subtotal = orderItems.reduce((sum, it) => sum + (it.quantity * it.unitPrice), 0);
  const taxAmount = orderItems.reduce((sum, it) => sum + (it.taxAmount || 0), 0);
  const grandTotal = subtotal + taxAmount + (order.shippingCharges || 0);

  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <p><strong>Order Date:</strong> {new Date(order.orderDate || order.createdAt).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          })}</p>
          <p><strong>Expected Delivery:</strong> {order.expectedDeliveryDate ? new Date(order.expectedDeliveryDate).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          }) : 'Not specified'}</p>
          {order.deliveryFrom && (
            <p><strong>Delivery From:</strong> {order.deliveryFrom}</p>
          )}
          {order.deliveryTo && (
            <p><strong>Delivery To:</strong> {order.deliveryTo}</p>
          )}
        </Col>
        <Col md={6}>
          <p><strong>Supplier:</strong> {order.supplier?.business_name || "N/A"}</p>
          <p><strong>Contact Person:</strong> {order.supplier?.contact_person || "N/A"}</p>
          <p><strong>Phone:</strong> {order.supplier?.phone || "N/A"}</p>
          {order.paymentTerms && (
            <p><strong>Payment Terms:</strong> {order.paymentTerms}</p>
          )}
          {order.remarks && (
            <p><strong>Notes:</strong> {order.remarks}</p>
          )}
        </Col>
      </Row>

      <h6 className="mt-4">Ordered Items</h6>
      <Table bordered responsive>
        <thead className="table-light">
          <tr>
            <th>#</th>
            <th>Packaging Material</th>
            <th>Size/Specification</th>
            <th>Qty</th>
            <th>Unit Price (₹)</th>
            <th>Tax (%)</th>
            <th>Tax Amount (₹)</th>
            <th>Total (₹)</th>
          </tr>
        </thead>
        <tbody>
          {orderItems.map((it, idx) => (
            <tr key={idx}>
              <td>{idx + 1}</td>
              <td>
                <div>
                  <strong>{it.packingMaterial?.name || "N/A"}</strong>
                  {it.packingMaterial?.alias && (
                    <div className="text-muted small">Alias: {it.packingMaterial.alias}</div>
                  )}
                </div>
              </td>
              <td>{it.packingMaterial?.size || "—"}</td>
              <td>{it.quantity?.toLocaleString() || 0} {it.unit}</td>
              <td>{it.unitPrice?.toFixed(2) || "0.00"}</td>
              <td>{it.taxRate?.toFixed(2) || 0}%</td>
              <td>{it.taxAmount?.toFixed(2) || "0.00"}</td>
              <td>{((it.quantity * it.unitPrice) + (it.taxAmount || 0)).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <div className="text-end">
        <p>Subtotal: ₹{subtotal.toFixed(2)}</p>
        <p>Tax: ₹{taxAmount.toFixed(2)}</p>
        {order.shippingCharges > 0 && (
          <p>Shipping: ₹{order.shippingCharges.toFixed(2)}</p>
        )}
        <h5>Grand Total: ₹{grandTotal.toFixed(2)}</h5>
      </div>
    </>
  );
}
